export default __webpack_public_path__ + "ed1cacdd6e927d562977f264b34faf0c.woff";